export default __webpack_public_path__ + "static/media/biofit_warranty_chair.7e9433cf.svg";